import { DeleteOutlined, EditOutlined, PlusCircleOutlined, PlusOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Dropdown, Flex, message, Modal, Row, Select } from "antd";
import usePosition from "features/company/hooks/usePosition";
import { getRoleOptions } from "features/masterData/services/optionsApi";
import { setRolePermission } from "features/masterData/slices/optionsSlice";
import usePending from "features/requestApproval/hook/usePendingApi";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import { editWorkFlow, getWorkFlowByType, resetToDefault } from "../services/leaveTypeApi";
import { setIsLoading, setWorkFlowByType } from "../slices/workFlowSlice";
import FormAntd from "components/form/FormProvide/FormAntd";
import { FormRadio } from "components/form/FormProvide";
import { useForm } from "antd/es/form/Form";
import { useMatch } from "react-router-dom";
import useWelfare from "features/payrollSetting/hooks/useWelfare";

const useWorkFlow = ({
    type = null
}) => {
    const { t, i18n } = useTranslation();
    const [choice, setChoice] = useState('N')

    const { workFlowTypeByGroup, currentFlow, workFlowByType } = useSelector((state) => state.workFlow);
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);
    const welfareWorkflow = useSelector((state) => state.welfare.welfareWorkflow);
    const currentWelfare = useSelector((state) => state.payroll.currentWelfare || {});
    const { getWorkFlowByTypeForWelfare } = useWelfare();

    const [list, setList] = useState([{
        type: '1'
    }])
    const dispatch = useDispatch();
    const isEditWelfarePage = useMatch('/configuration/payroll/welfare/:id/edit');

    const {
        modifiedEmployeeOptions = [],
    } = usePending();

    const {
        modifiedPositionOptions = [],
    } = usePosition(() => { });
    // console.log("modifiedPositionOptions", modifiedPositionOptions);
    const rolePermissionOptions = useSelector(
        (state) => state.options.rolePermissionOptions
    );

    const getRolePermission = useCallback(async () => {
        if (!currentCompany) return null;
        try {
            dispatch(setIsLoading(true));
            const response = await getRoleOptions({
                requestId: generateRandomString(),
                companyId: currentCompany,
            });
            dispatch(setRolePermission(response?.data?.content));
        } catch (error) {
            message.error(t("common.error"))
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        getRolePermission()
    }, [getRolePermission])


    const modifiedRolePermissionOptions = useMemo(() => {
        const modifiedOptions = rolePermissionOptions?.map((opt) => ({
            ...opt,
            label: i18n.language === "en" ? opt.roleNameEn : opt.roleName,
            value: opt.roleId,
        }));
        return modifiedOptions;
    }, [i18n.language, rolePermissionOptions]);


    useEffect(() => {
        if (currentFlow && !isEditWelfarePage) {
            getWorkFlowByTypeFn(currentFlow)
        }
    }, [currentFlow, isEditWelfarePage])

    useEffect(() => {
        if (currentWelfare && isEditWelfarePage) {
            getWorkFlowByTypeForWelfare(currentWelfare?.welfareRunningCode)
        }
    }, [currentWelfare, currentWelfare?.welfareRunningCode, getWorkFlowByTypeForWelfare, isEditWelfarePage])

    useEffect(() => {
        // console.log("workFlowByType", workFlowByType);
        // function typeConvert(params) {
        //     if (params) {
        //         if (params.isChainOfCommand) return "1"
        //         if (params.role) return "2"
        //         if (params.position) return "3"
        //     }
        // }
        setList(isEditWelfarePage ? welfareWorkflow?.flowConfig || [] : workFlowByType?.flowConfig || [])
        setListWorkFlow(isEditWelfarePage ? welfareWorkflow?.otherFlowConfig || [] : workFlowByType?.otherFlowConfig || [])
    }, [workFlowByType, welfareWorkflow, isEditWelfarePage])

    const onSave = useCallback(
        async (prop) => {
            // console.log("proppropprop", prop);
            let flowConfig = [...list?.map?.((o, step) => {
                return {
                    ...o,
                    role: o?.role?.roleId,
                    position: o?.position?.positionId,
                    requesterList: o?.requesterList?.map?.(o => o.employeeId),
                    step: step + 1
                }
            })]
            let otherFlowConfig = [...listworkflow?.map?.((o) => {
                return ({
                    ...o,
                    flowConfig: o?.flowConfig?.map?.((v1, step) => {
                        return {
                            ...v1,
                            role: v1?.role?.roleId,
                            position: v1?.position?.positionId,
                            requesterList: v1?.requesterList?.map?.(v1 => v1.employeeId),
                            step: step + 1
                        }
                    }
                    )
                })
            })]

            const workFlowTypeValue = type === "WELFARE" && currentWelfare?.welfareRunningCode
                ? currentWelfare?.welfareRunningCode
                : currentFlow;

            const baseWorkFlowData = type === "WELFARE" && welfareWorkflow
                ? welfareWorkflow
                : workFlowByType;

            let req = {
                ...baseWorkFlowData,
                workFlowGroup: type,
                workFlowType: workFlowTypeValue,
                applyAll: prop,
                flowConfig,
                otherFlowConfig
            }
            // console.log("req", req);
            await editWorkFlowFn(req)
        },
        [currentFlow, type, list, workFlowByType, currentCompany, currentEmployee, currentWelfare?.welfareRunningCode],
    )

    const onCancel = useCallback(
        () => {
            getWorkFlowByTypeFn(currentFlow)
        },
        [currentFlow],
    )

    const getWorkFlowByTypeFn = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                let res = await getWorkFlowByType({
                    workFlowGroup: type,
                    workFlowType: values,
                    companyId: currentCompany
                });
                dispatch(setWorkFlowByType(res?.data?.content || []))
            } catch (error) {
                message.error(t("common.error"))
                dispatch(setWorkFlowByType({}))
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [type, currentCompany, currentEmployee],
    )

    const editWorkFlowFn = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                let res = await editWorkFlow({
                    ...values,
                    companyId: currentCompany,
                    actionId: currentEmployee
                });

                if (isEditWelfarePage) {
                    getWorkFlowByTypeForWelfare(currentWelfare?.welfareRunningCode)
                } else {
                    getWorkFlowByTypeFn(currentFlow)
                }
                message.success(t("common.success"))
            } catch (error) {
                message.error(t("common.error"))
            } finally {
            }
        },
        [type, currentCompany, currentEmployee, currentFlow, currentWelfare?.welfareRunningCode, getWorkFlowByTypeFn, getWorkFlowByTypeForWelfare],
    )

    const resetToDefaultFn = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            await resetToDefault({
                companyId: currentCompany,
                actionId: currentEmployee,
                mappingId: workFlowByType?.workFlowMappingId,
                workFlowGroup: type
            })
            getWorkFlowByTypeFn(currentFlow)
        } catch (error) {
            message.error(t("common.error"))
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentFlow, workFlowByType, currentCompany, currentEmployee])

    const [listworkflow, setListWorkFlow] = useState([])
    const handleAddComponent = useCallback((index, type) => {
        const newList = [...list];
        newList.splice(index + 1, 0, { type });
        setList(newList);
    }, [list]);

    // const reset = useCallback(() => {
    //     resetToDefault()
    //     getWorkFlowByTypeFn(currentFlow)
    // }, []);

    const onDelete = useCallback((values) => {
        setList(list.filter((o, index) => index != values));
    }, [list]);

    const [showSelect, setShowSelect] = useState(true);

    const onEdit = useCallback((values) => {
        // console.log('Editing...', values);
        // Hide the Select component when onEdit is called
        setShowSelect(false);
    }, []);

    const handleDelete = useCallback(
        (fn = () => { }) => {
            // const modifiedValues = { ...values };
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {t('workflow.are-you-sure-to-delete-this-item')}

                        </p>
                    </>
                ),
                onOk() {
                    if (fn) {
                        fn()
                    }
                },
                okText: <span>{t("common.confirm")}</span>,
                cancelText: <span>{t("common.cancel")}</span>,
            });
        },
        []
    );
    const [formUse] = useForm(null);

    const HandleSave = useCallback(
        (fn = () => { }) => {
            // const modifiedValues = { ...values };
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <FormAntd form={formUse} initialValues={{ choice: "N" }}>{
                            <Flex vertical>
                                {t('common.save')}
                                {currentFlow == 'MAIN_FLOW' &&
                                    <FormRadio
                                        // required={true}
                                        name="choice"
                                        // label={t('common.save')}
                                        options={[
                                            {
                                                label: i18n.language == "en" ? "replace all type" : "แทนที่ทั้งหมด",
                                                value: "Y",
                                            },
                                            {
                                                label: i18n.language == "en" ? "save main only" : "บันทึกเงื่อนไขหลักเท่านั้น",
                                                value: "N",
                                            },
                                        ]}>
                                    </FormRadio>
                                }
                            </Flex>
                        }
                        </FormAntd>
                    </>
                ),
                onOk() {
                    if (onSave) {
                        onSave(formUse.getFieldValue('choice'))
                        formUse.setFieldValue("choice", 'N')
                    }
                },
                okText: <span>{t("common.confirm")}</span>,
                cancelText: <span>{t("common.cancel")}</span>,
            })

        },
        [onSave, formUse, currentFlow]
    );

    // function HandleSave() {
    //     Modal.confirm({
    //         title: "Confirmation",
    //         content: (
    //             <>
    //                 <Flex vertical>
    //                     {t('common.save')}
    //                     <Radio.Group
    //                         onChange={(e) => {
    //                             // console.log("e.target.value", e.target.value);
    //                             setChoice(e.target.value);
    //                         }}
    //                         // value={choice}
    //                         defaultValue={choice}
    //                     >
    //                         <Flex vertical>
    //                             <Radio value={"Y"}>
    //                                 {t("signup.input.thai")}
    //                             </Radio>
    //                             <Radio value={"N"}>
    //                                 {t("signup.input.other")}
    //                             </Radio>
    //                         </Flex>
    //                     </Radio.Group>
    //                 </Flex>
    //             </>
    //         ),
    //         onOk() {
    //             if (onSave) {
    //                 onSave()
    //             }
    //         },
    //         okText: "CONFIRM",
    //         cancelText: "CANCEL",
    //     });
    // }

    const PlusDropdown = useCallback(
        (index) => {
            // all_chain_of_command
            // role
            // userlist
            // position
            return (
                <Flex vertical style={{ display: "flex", paddingTop: "1vw", alignSelf: "center" }}>
                    <Flex style={{ padding: "30px 0px 50px 0px" }}>
                        <RightOutlined style={{ color: "#1890FF" }} />
                    </Flex>
                    <Dropdown
                        onOpenChange={(oc) => {
                            // console.log("oc", oc);
                        }}
                        menu={{
                            items: [
                                {
                                    onClick: () => {
                                        // console.log("index", list, index, list.length);
                                        let temp = [...list]
                                        temp.splice((index == null ? 0 : index + 1), 0, { type: 'role' });
                                        setList([...temp.map((o, step) => {
                                            return {
                                                ...o,
                                                // step: step + 1
                                            }
                                        }).map((o, step) => ({ ...o, step: step + 1 }))])
                                    },
                                    key: "role",
                                    label: (<span
                                    >
                                        {t("workflow.label.user_group")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, list.length);
                                        let temp = [...list]
                                        temp.splice((index == null ? 0 : index + 1), 0, { type: 'position' });
                                        setList([...temp.map((o, step) => {
                                            return {
                                                ...o,
                                                // step: step + 1
                                            }
                                        }).map((o, step) => ({ ...o, step: step + 1 }))])
                                    },
                                    key: "position",
                                    label: (<span
                                    >
                                        {t("workflow.label.position")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, list.length);

                                        let temp = [...list]
                                        temp.splice((index == null ? 0 : index + 1), 0, { type: 'userlist' });
                                        setList([...temp.map((o, step) => {
                                            return {
                                                ...o,
                                                // step: step + 1
                                            }
                                        }).map((o, step) => ({ ...o, step: step + 1 }))])
                                    },
                                    key: "userlist",
                                    label: (
                                        <span >
                                            {t("workflow.label.individual")}
                                        </span>
                                    ),
                                },
                            ]
                        }}>
                        <PlusCircleOutlined style={{ color: "#1890FF" }} />
                    </Dropdown>
                </Flex>
            )
        },
        [list, setList],
    )

    const PlusDropdownNew = useCallback(
        (index, parent) => {
            // console.log("index, parent", index, parent);
            return (
                <Flex vertical style={{ display: "flex", paddingTop: "1vw", alignSelf: "center" }}>
                    <Flex style={{ padding: "30px 0px 50px 0px" }}>
                        <RightOutlined style={{ color: "#1890FF" }} />
                    </Flex>
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    onClick: () => {
                                        // console.log(" listworkflow.find((o,idx)=> index==idx)", listworkflow, parent);
                                        setListWorkFlow(listworkflow?.map((o, idx) => {
                                            if (idx == parent) {
                                                let data = [...(o.flowConfig ?? [])]
                                                // console.log("idx == index", idx, index, data.length);
                                                if (data.length == index || data.length == 0) {
                                                    data.push({ type: 'all_chain_of_command', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) })
                                                } else {
                                                    data.splice(index ? index : 1, 0, { type: 'all_chain_of_command', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) });
                                                }
                                                return {
                                                    ...o,
                                                    flowConfig: data?.map((o, step) => {
                                                        return { ...o, step: step + 1 }
                                                    })
                                                }
                                            } else {
                                                return {
                                                    ...o
                                                }
                                            }
                                        }))
                                    },
                                    key: "all_chain_of_command",
                                    label: (<span
                                    >
                                        {t("workflow.label.chain_of_command")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log(" listworkflow.find((o,idx)=> index==idx)", listworkflow, parent);
                                        setListWorkFlow(listworkflow?.map((o, idx) => {
                                            if (idx == parent) {
                                                let data = [...(o.flowConfig ?? [])]
                                                // console.log("idx == index", idx, index, data.length);
                                                if (data.length == index || data.length == 0) {
                                                    data.push({ type: 'role', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) })
                                                } else {
                                                    data.splice(index ? index : 1, 0, { type: 'role', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) });
                                                }
                                                return {
                                                    ...o,
                                                    flowConfig: data?.map((o, step) => {
                                                        return { ...o, step: step + 1 }
                                                    })
                                                }
                                            } else {
                                                return {
                                                    ...o
                                                }
                                            }
                                        }))
                                    },
                                    key: "role",
                                    label: (<span
                                    >
                                        {t("workflow.label.user_group")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, listworkflow.length);
                                        setListWorkFlow(listworkflow?.map((o, idx) => {
                                            if (idx == parent) {
                                                let data = [...(o.flowConfig ?? [])]
                                                // console.log("idx == index", idx, index, data.length);
                                                if (data.length == index || data.length == 0) {
                                                    data.push({ type: 'position', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) })
                                                } else {
                                                    data.splice(index ? index : 1, 0, { type: 'position', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) });
                                                }
                                                return {
                                                    ...o,
                                                    flowConfig: data?.map((o, step) => {
                                                        return { ...o, step: step + 1 }
                                                    })
                                                }
                                            } else {
                                                return {
                                                    ...o
                                                }
                                            }
                                        }))
                                    },
                                    key: "position",
                                    label: (<span
                                    >
                                        {t("workflow.label.position")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, listworkflow.length);
                                        setListWorkFlow(listworkflow?.map((o, idx) => {
                                            if (idx == parent) {
                                                let data = [...(o.flowConfig ?? [])]
                                                // console.log("idx == index", idx, index, data.length);
                                                if (data.length == index || data.length == 0) {
                                                    data.push({ type: 'userlist', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) })
                                                } else {
                                                    data.splice(index ? index : 1, 0, { type: 'userlist', flowConfig: [], key: (parent + "_" || "") + (data.length ?? 0) });
                                                }
                                                return {
                                                    ...o,
                                                    flowConfig: data?.map((o, step) => {
                                                        return { ...o, step: step + 1 }
                                                    })
                                                }
                                            } else {
                                                return {
                                                    ...o
                                                }
                                            }
                                        }))
                                    },
                                    key: "userlist",
                                    label: (
                                        <span >
                                            {t("workflow.label.individual")}
                                        </span>
                                    ),
                                },
                            ]
                        }}>
                        <PlusCircleOutlined style={{ color: "#1890FF" }} />
                    </Dropdown>
                </Flex>
            )
        },
        [listworkflow, setListWorkFlow],
    )

    const addNewWorkFlow = useCallback(
        (index) => {
            return (
                <Flex vertical style={{ display: "flex", paddingTop: "1vw" }}>
                    <Dropdown
                        onOpenChange={(oc) => {
                            // console.log("oc", oc);
                        }}
                        menu={{
                            items: [
                                {
                                    onClick: () => {
                                        // console.log("index", listworkflow, index, listworkflow.length);
                                        let temp = [...listworkflow]
                                        temp.push({ step: listworkflow.length, flowConfig: [{ type: 'role', step: 1, workFlowConfigType: "REQUESTER" }] });
                                        setListWorkFlow([...temp])
                                    },
                                    key: "role",
                                    label: (<span
                                    >
                                        {t("workflow.label.user_group")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, listworkflow.length);
                                        let temp = [...listworkflow]
                                        temp.push({ step: listworkflow.length, flowConfig: [{ type: 'position', step: 1, workFlowConfigType: "REQUESTER" }] });
                                        setListWorkFlow([...temp])
                                    },
                                    key: "position",
                                    label: (<span
                                    >
                                        {t("workflow.label.position")}
                                    </span>),
                                },
                                {
                                    onClick: () => {
                                        // console.log("index", index, listworkflow.length);
                                        let temp = [...listworkflow]
                                        temp.push({ step: listworkflow.length, flowConfig: [{ type: 'userlist', step: 1, workFlowConfigType: "REQUESTER" }] });
                                        setListWorkFlow([...temp])
                                    },
                                    key: "userlist",
                                    label: (
                                        <span >
                                            {t("workflow.label.individual")}
                                        </span>
                                    ),
                                },
                            ]
                        }}>
                        <Button style={{
                            width: "10vw",
                            borderRadius: "6rem",
                            height: "2.5vw",
                            color: "#1890FF"
                        }}>
                            <PlusOutlined />{t('workflow.new-workflow')}
                        </Button>
                    </Dropdown>
                </Flex>
            )
        },
        [listworkflow, setListWorkFlow],
    )

    // console.log("listworkflowlistworkflow", listworkflow);

    const RenderCell = useCallback(
        () => {
            // console.log("memo1", list);
            return list.map((o, index) => {
                // console.log("o.step || o.type", o.workFlowConfigType, o.type);
                function request(type) {
                    return <Flex gap={40} style={{ display: "flex" }}>
                        {requestModel()}
                    </Flex>;
                }
                function approveModel(type) {
                    switch (type) {
                        case 'all_chain_of_command':
                            return <Flex gap={40} style={{ display: "flex" }}>
                                <ChainOfCommand param={{ ...o, approve: 'Y' }} />
                                {PlusDropdown(index)}
                            </Flex>;
                        case 'role':
                            return <Flex gap={40} style={{ display: "flex" }}>
                                <ApproveByRole param={{ ...o, approve: 'Y' }} />
                                {PlusDropdown(index)}
                            </Flex>;
                        case 'userlist':
                            return <Flex gap={40} style={{ display: "flex" }}>
                                <ApprovebyPerson param={{ ...o, approve: 'Y' }} />
                                {PlusDropdown(index)}
                            </Flex>;
                        case 'position':
                            return <Flex gap={40} style={{ display: "flex" }}>
                                <ApproveByPosition param={{ ...o, approve: 'Y' }} />
                                {PlusDropdown(index)}
                            </Flex>;
                        default: return null
                    }
                }

                if (o.workFlowConfigType == "REQUESTER") {
                    return request()
                } else {
                    return approveModel(o.type)
                }


            })
        },
        [list, listworkflow, setList, setListWorkFlow, PlusDropdown, modifiedEmployeeOptions],
    )
    const RenderCellTwo = useCallback(
        () => {
            // // console.log("memo1", list);
            // return list.map((o, index) => {
            //     switch (o.type) {
            //         case 'all_chain_of_command':
            //             return <Flex gap={40} style={{ display: "flex" }}>
            //                 {chainOfCommand()}
            //                 {PlusDropdown(index)}
            //             </Flex>;
            //         case 'role':
            //             return <Flex gap={40} style={{ display: "flex" }}>
            //                 {approveByRole()}
            //                 {PlusDropdown(index)}
            //             </Flex>;
            //         case 'userlist':
            //             return <Flex gap={40} style={{ display: "flex" }}>
            //                 {byPerson()}
            //                 {PlusDropdown(index)}
            //             </Flex>;
            //         case 'position':
            //             return <Flex gap={40} style={{ display: "flex" }}>
            //                 {approveByPosition()}
            //                 {PlusDropdown(index)}
            //             </Flex>;
            //     }
            // })
        },
        [listworkflow, list, listworkflow, setList, setListWorkFlow, PlusDropdown, modifiedEmployeeOptions],
    )

    const RenderNewWorkFlow = useCallback(
        (dataSource) => {
            return dataSource?.map?.((o, index) => {

                function approveModel(v1, type) {
                    switch (type) {
                        case 'all_chain_of_command':
                            return <Flex gap={40} style={{ display: "flex", justifyContent: "center" }}>
                                <ChainOfCommand param={{ ...v1, approve: 'Y', other: index }} />
                                {PlusDropdownNew(v1.step, index)}
                            </Flex>;
                        case 'role':
                            return <Flex gap={40} style={{ display: "flex", justifyContent: "center" }}>
                                <ApproveByRole param={{ ...v1, approve: 'Y', other: index }} />
                                {PlusDropdownNew(v1.step, index)}
                            </Flex>;
                        case 'userlist':
                            return <Flex gap={40} style={{ display: "flex", justifyContent: "center" }}>
                                <ApprovebyPerson param={{ ...v1, approve: 'Y', other: index }} />
                                {PlusDropdownNew(v1.step, index)}
                            </Flex>;
                        case 'position':
                            return <Flex gap={40} style={{ display: "flex" }}>
                                <ApproveByPosition param={{ ...v1, approve: 'Y', other: index }} />
                                {PlusDropdownNew(v1.step, index)}
                            </Flex>;
                        default: return null
                    }
                }
                return <Flex gap={40}
                    vertical={false}
                >
                    {
                        o?.flowConfig?.map?.(v1 => {
                            // console.log("v1", v1);
                            if (v1.workFlowConfigType == "REQUESTER") {
                                return approveModel(v1, v1.type)
                            } else {
                                return approveModel(v1, v1.type)
                            }
                        })
                    }
                </Flex>
            })
        },
        [list, listworkflow, setList, setListWorkFlow, addNewWorkFlow, modifiedEmployeeOptions],
    )

    const selectedText = (selectedValue) => {
        switch (selectedValue) {
            case 'all_chain_of_command':
                return (
                    <Flex vertical>
                        <Flex style={{ fontSize: "1vw", width: "11vw" }}>
                            {i18n.language == "en" ? "Approve All" : "อนุมัติทุกลำดับ"}
                        </Flex>
                        <Flex style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                            {i18n.language == "en" ? "Must be approved by everyone in the chain of command." : "ต้องได้รับการอนุมัติจากทุกคนตามลำดับในสายบังคับบัญชา"}
                        </Flex>
                    </Flex>
                );
            case 'supervisor':
                return (
                    <Flex vertical>
                        <Flex style={{ fontSize: "1vw", width: "11vw" }}>
                            {i18n.language == "en" ? "Only direct supervisor" : "เฉพาะหัวหน้าโดยตรง"}
                        </Flex>
                        <Flex style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                            {i18n.language == "en" ? "Must be approved by direct supervisor only." : "ต้องได้รับการอนุมัติจากหัวหน้าโดยตรงเท่านั้น"}
                        </Flex>
                    </Flex>
                );
            case 'no_require':
                return (
                    <Flex style={{ fontSize: "1vw", width: "11vw" }}>
                        {i18n.language == "en" ? "No approval required" : "ไม่ต้องอนุมัติ"}
                    </Flex>
                );
            default:
                return null;
        }
    };


    function ChainOfCommand(props) {
        const { param } = props;
        const [edit, setEdit] = useState(param.edit || false)
        return (
            <Flex vertical>{param.workFlowConfigType == "REQUESTER" ?
                <Card
                    styles={{
                        body: {
                            alignContent: "center",
                            padding: "16px 16px 10px 16px",
                            height: "100%"
                        }
                    }}
                    style={{
                        placeContent: "center",
                        alignSelf: "center",
                        display: "flex",
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "transparent",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        textAlign: "center",
                        alignContent: "center"
                    }}>
                    <Flex
                        style={{
                            display: "flex",
                            placeContent: "center",
                            backgroundColor: "#D4EBFF",
                            padding: "0.4vw",
                            textAlign: "center",
                            borderStyle: "solid",
                            borderColor: "#1890FF",
                            borderRadius: "2rem",
                            borderWidth: "2px",
                            color: "#1890FF",
                            fontSize: "0.8vw",
                            width: "7vw"
                        }}>{t("workflow.label.requester")}
                    </Flex>
                </Card>
                : <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        width: "16vw",
                        alignSelf: "center",
                        borderStyle: "solid",
                        borderColor: "transparent",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw"
                    }}>
                    <Flex style={{ justifyContent: "center", }}>
                        <Flex style={{
                            backgroundColor: "#1890FF",
                            width: "2vw",
                            height: "2vw",
                            justifyContent: "center",
                            borderRadius: "60rem"
                        }}>
                            <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param.step - 1}</span>
                        </Flex>
                    </Flex>
                </Card>
            }
                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        width: "100%",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "9vw",
                            width: "0.2vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex style={{
                            minWidth: "12.5vw",
                            maxWidth: "12.5vw",
                        }} vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {i18n.language == "en" ? "According to the chain of command" : "ตามสายบังคับบัญชา"}
                            </Flex>
                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                                {i18n.language == "en" ? "Approval respectively" : "อนุมัติตามลำดับขั้น"}
                            </span>
                            <Divider
                                styles={{
                                    body: {

                                    }
                                }}
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            {edit ? (
                                <Select
                                    name="chainOfCommand"
                                    placeholder={i18n.language == "en" ? "According to the chain of command" : "ตามสายบังคับบัญชา"}
                                    size="large"
                                    value={param?.condition}
                                    onChange={(e) => {
                                        console.log("e", param, e);

                                        if (param.other == null) {
                                            // console.log("temptemptemp2", listworkflow);
                                            setList(list.map(o => {
                                                if (o.step == param.step) {
                                                    return {
                                                        ...o,
                                                        condition: e,
                                                        isEdit: true,
                                                        edit: true,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...o
                                                    }
                                                }
                                            }))
                                        } else {
                                            setList(list?.map(o => {
                                                return {
                                                    ...o,
                                                    isEdit: true,
                                                }
                                            }))
                                            console.log("index",);

                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                console.log("index == param.other", index, param.other);
                                                if (index == param.other) {
                                                    console.log("o.flowConfig.length ", o.flowConfig);
                                                    if (o.flowConfig.length == 0) {
                                                        o.flowConfig.push({ type: "all_chain_of_command" })
                                                        return o
                                                    } else {
                                                        return {
                                                            ...o,
                                                            flowConfig: o.flowConfig.map((v1, step) => {
                                                                if (v1.step == param.step) {
                                                                    return {
                                                                        ...v1,
                                                                        condition: e,
                                                                        isEdit: true,
                                                                        edit: true
                                                                    }
                                                                }
                                                                return v1
                                                            })
                                                        }
                                                    }

                                                }
                                                return o
                                            }))
                                        }
                                    }}
                                    options={[
                                        { value: 'all_chain_of_command', label: <span>{i18n.language == "en" ? "Approve All" : "อนุมัติทุกลำดับ"} </span> },
                                        { value: 'supervisor', label: <span>{i18n.language == "en" ? "Only direct supervisor" : "เฉพาะหัวหน้าโดยตรง"}</span> },
                                        { value: 'no_require', label: <span>{i18n.language == "en" ? "No approval required" : "ไม่ต้องอนุมัติ"}</span> },
                                    ]}
                                />
                            ) : (selectedText(param.condition))}
                        </Flex>
                        <span style={{ color: "#AEAEAE" }}> <EditOutlined style={{ paddingRight: "12px" }} onClick={() => {
                            setEdit(!edit)
                            if (edit) {
                                setList(list?.map(o => {
                                    if (o.step == param.step) {
                                        return {
                                            ...o,
                                            edit: false,
                                        }
                                    }
                                    else {
                                        return {
                                            ...o
                                        }
                                    }
                                }))
                                setListWorkFlow(listworkflow?.map((o, index) => {
                                    // console.log("index == param.other", index, param.other);
                                    if (index == param.other) {
                                        // console.log("o.flowConfig.length ", o.flowConfig.length);
                                        return {
                                            ...o,
                                            flowConfig: o.flowConfig.map((v1, step) => {
                                                if (v1.step == param.step) {
                                                    return {
                                                        ...v1,
                                                        isEdit: true,
                                                        edit: false
                                                    }
                                                }
                                                return v1
                                            })
                                        }
                                    }
                                    return o
                                }))
                            }

                        }} />
                            <DeleteOutlined onClick={() => {
                                handleDelete(() => {
                                    if (param.other == null) {
                                        setList(list.filter(o => o.step != param.step).map((o, step) => {
                                            return {
                                                ...o,
                                                step: step + 1,
                                                isEdit: true
                                            }
                                        }))
                                    } else {
                                        setList(list?.map(o => {
                                            return {
                                                ...o,
                                                isEdit: true,
                                            }
                                        }))
                                        if (param.step == 1) {
                                            setListWorkFlow(
                                                listworkflow.filter((o, index) => index != param.other).map((o, step) => {
                                                    return {
                                                        ...o,
                                                        step: step + 1,
                                                        isEdit: true,
                                                        edit: true
                                                    }
                                                })
                                            )
                                        } else {
                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                if (index == param.other) {
                                                    return {
                                                        ...o,
                                                        flowConfig: o?.flowConfig?.filter((v1, step) => v1.step != param.step)
                                                    }
                                                }
                                                return o
                                            }))
                                        }
                                    }
                                })
                            }} />
                        </span>
                    </Flex >
                </Card >
            </Flex>
        )
    }

    const [isEditing, setIsEditing] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleSelectChange = (value) => {
        setSelectedValue(value);
        setIsEditing(false);
    };

    const handleEditClick = () => {
        setIsEditing(true);
        // console.log("Click Edit daiiiiiii");

    };

    function ApproveByRole(props) {
        const { param } = props;
        // console.log("ApproveByRole", param.other, param);
        const [edit, setEdit] = useState(param.edit || false)
        return (
            <Flex vertical>
                {param.workFlowConfigType == "REQUESTER" ? <Card
                    styles={{
                        body: {
                            alignContent: "center",
                            padding: "16px 16px 10px 16px",
                            height: "100%"
                        }
                    }}
                    style={{
                        alignSelf: "center",
                        placeContent: "center",
                        display: "flex",
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "transparent",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        textAlign: "center",
                        alignContent: "center"
                    }}>
                    <Flex
                        style={{
                            display: "flex",
                            placeContent: "center",
                            backgroundColor: "#D4EBFF",
                            padding: "0.4vw",
                            textAlign: "center",
                            borderStyle: "solid",
                            borderColor: "#1890FF",
                            borderRadius: "2rem",
                            borderWidth: "2px",
                            color: "#1890FF",
                            fontSize: "0.8vw",
                            width: "7vw"
                        }}>{t("workflow.label.requester")}
                    </Flex>
                </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            alignSelf: "center",
                            // marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param.step - 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
                }

                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        // width: "16vw",
                        // height: "7vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw",
                        gap: "20px"
                    }}>

                    <Flex>
                        <Divider
                            style={{
                                height: "12vh",
                                width: "0.1vw",
                                backgroundColor: "#1890FF",
                                borderBlockStart: "none",
                                borderRadius: "1vw"
                            }}
                            type="vertical"
                        />
                        <Flex vertical>
                            <span style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.approve_by_user_group")}
                            </span>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            {/* <Flex vertical> */}
                            {edit ? (
                                <Select
                                    name="group"
                                    placeholder={t("workflow.label.user_group")}
                                    size="large"
                                    value={param?.role?.roleId}
                                    onChange={(e) => {
                                        // console.log("param.other", param.other);
                                        if (param.other == null) {
                                            // console.log("temptemptemp2", listworkflow);
                                            setList(list.map(o => {
                                                if (o.step == param.step) {
                                                    return {
                                                        ...o,
                                                        role: { ...o.role, roleId: e },
                                                        isEdit: true,
                                                        edit: true,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...o
                                                    }
                                                }
                                            }))
                                        } else {
                                            setList(list?.map(o => {
                                                return {
                                                    ...o,
                                                    isEdit: true,
                                                }
                                            }))

                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                // console.log("index == param.other", index, param.other);
                                                if (index == param.other) {
                                                    // console.log("o.flowConfig.length ", o.flowConfig.length);
                                                    if (o.flowConfig.length == 0) {
                                                        o.flowConfig.push({ type: "role" })
                                                        return o
                                                    } else {
                                                        return {
                                                            ...o,
                                                            flowConfig: o.flowConfig.map((v1, step) => {
                                                                if (v1.step == param.step) {
                                                                    return {
                                                                        ...v1,
                                                                        role: { ...v1.role, roleId: e },
                                                                        isEdit: true,
                                                                        edit: true
                                                                    }
                                                                }
                                                                return v1
                                                            })
                                                        }
                                                    }

                                                }
                                                return o
                                            }))
                                        }
                                    }}
                                    options={modifiedRolePermissionOptions}
                                />
                            ) : (
                                <Flex vertical>
                                    <span style={{ fontSize: "1vw" }}>
                                        {modifiedRolePermissionOptions?.find?.(o => o.value == param?.role?.roleId)?.label || t("workflow.label.user_group")}
                                    </span>
                                    <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                                        {i18n.language == "en" ? "Must have at least 1 person to approve." : "ต้องมีผู้อนุมัติอย่างน้อย 1 คน"}
                                    </span>
                                </Flex>
                            )}

                            {/* </Flex> */}
                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined
                                // onClick={() => onEdit({ id: deindex })}
                                onClick={() => {
                                    setEdit(!edit)
                                    if (edit) {
                                        setList(list?.map(o => {
                                            if (o.step == param.step) {
                                                return {
                                                    ...o,
                                                    edit: false,
                                                }
                                            }
                                            else {
                                                return o
                                            }
                                        }))

                                        setListWorkFlow(listworkflow?.map((o, index) => {
                                            // console.log("index == param.other", index, param.other);
                                            if (index == param.other) {
                                                // console.log("o.flowConfig.length ", o.flowConfig.length);
                                                return {
                                                    ...o,
                                                    flowConfig: o.flowConfig.map((v1, step) => {
                                                        if (v1.step == param.step) {
                                                            return {
                                                                ...v1,
                                                                isEdit: true,
                                                                edit: false
                                                            }
                                                        }
                                                        return v1
                                                    })
                                                }
                                            }
                                            return o
                                        }))
                                    }
                                }}
                                style={{ paddingRight: "12px" }}
                            />
                            <DeleteOutlined onClick={() => {
                                handleDelete(() => {
                                    if (param.other == null) {
                                        setList(list.filter(o => o.step != param.step).map((o, step) => {
                                            return {
                                                ...o,
                                                step: step + 1,
                                                isEdit: true
                                            }
                                        }))
                                    } else {
                                        setList(list?.map(o => {
                                            return {
                                                ...o,
                                                isEdit: true,
                                            }
                                        }))
                                        if (param.step == 1) {
                                            setListWorkFlow(
                                                listworkflow.filter((o, index) => index != param.other).map((o, step) => {
                                                    return {
                                                        ...o,
                                                        step: step + 1,
                                                        isEdit: true,
                                                        edit: true
                                                    }
                                                })
                                            )
                                        } else {
                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                if (index == param.other) {
                                                    return {
                                                        ...o,
                                                        flowConfig: o?.flowConfig?.filter((v1, step) => v1.step != param.step)
                                                    }
                                                }
                                                return o
                                            }))
                                        }
                                    }
                                })
                            }} />
                        </span>

                    </Flex>
                </Card>
            </Flex>
        )
    }
    function ApproveByPosition(props) {
        const { param } = props;
        // console.log("ApproveByPosition", param.other, param);
        const [edit, setEdit] = useState(param.edit || false)
        return (
            <Flex vertical>{
                param.workFlowConfigType == "REQUESTER" ? <Card
                    styles={{
                        body: {
                            alignContent: "center",
                            padding: "16px 16px 10px 16px",
                            height: "100%"
                        }
                    }}
                    style={{
                        placeContent: "center",
                        alignSelf: "center",
                        display: "flex",
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "transparent",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        textAlign: "center",
                        alignContent: "center",

                    }}>
                    <Flex
                        style={{
                            display: "flex",
                            placeContent: "center",
                            backgroundColor: "#D4EBFF",
                            padding: "0.4vw",
                            textAlign: "center",
                            borderStyle: "solid",
                            borderColor: "#1890FF",
                            borderRadius: "2rem",
                            borderWidth: "2px",
                            color: "#1890FF",
                            fontSize: "0.8vw",
                            width: "7vw"
                        }}>{t("workflow.label.requester")}
                    </Flex>
                </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            alignSelf: "center",
                            // marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param.step - 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
            }
                <Card
                    styles={{
                        body: {
                            padding: "16px",
                            width: "100%",
                        }
                    }}
                    style={{
                        // width: "21vw",
                        // height: "7vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "7.5vw",
                            width: "0.1vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex style={{
                            minWidth: "12.5vw",
                            maxWidth: "12.5vw",
                        }} vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.approve_by_position")}
                            </Flex>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            <Flex vertical style={{ rowGap: "8px" }}>
                                {edit ? (
                                    <>
                                        <Select
                                            value={param?.position?.positionId}
                                            name="group"
                                            placeholder={t("home.position")}
                                            size="large"
                                            options={modifiedPositionOptions}
                                            onChange={(e) => {
                                                // console.log("param.other == null", param.other == null);
                                                if (param.other == null) {
                                                    setList(list.map(o => {
                                                        if (o.step == param.step) {
                                                            return {
                                                                ...o,
                                                                position: { ...o.position, positionId: e },
                                                                isEdit: true,
                                                                edit: true
                                                            }
                                                        }
                                                        else {
                                                            return {
                                                                ...o
                                                            }
                                                        }
                                                    }))
                                                } else {
                                                    setList(list?.map(o => {
                                                        return {
                                                            ...o,
                                                            isEdit: true,
                                                        }
                                                    }))
                                                    setListWorkFlow(listworkflow?.map((o, index) => {
                                                        // console.log("index == param.other", index, param.other);
                                                        if (index == param.other) {
                                                            return {
                                                                ...o,
                                                                flowConfig: o.flowConfig.map((v1, step) => {
                                                                    if (v1.step == param.step) {
                                                                        return {
                                                                            ...v1,
                                                                            position: { ...o.position, positionId: e },
                                                                            isEdit: true,
                                                                            edit: true
                                                                        }
                                                                    }
                                                                    return v1
                                                                })
                                                            }
                                                        }
                                                        return o
                                                    }))
                                                }
                                            }}
                                        />
                                        {/* <Checkbox>กรณีไม่มี ให้ลำดับถัดไปอนุมัติ</Checkbox> */}
                                    </>
                                ) :
                                    (
                                        <Flex vertical>
                                            <span style={{ fontSize: "1vw" }}>
                                                {modifiedPositionOptions?.find?.(o => o.value == param?.position?.positionId)?.label || "-"}
                                            </span>
                                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                                                {t("workflow.label.must_approve_position")} {modifiedPositionOptions?.find?.(o => o.value == param?.position?.positionId)?.label}
                                            </span>
                                        </Flex>
                                    )}


                            </Flex>
                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined style={{ paddingRight: "12px" }} onClick={() => {
                                setEdit(!edit)
                                if (edit) {
                                    setList(list?.map(o => {
                                        if (o.step == param.step) {
                                            return {
                                                ...o,
                                                edit: false,
                                            }
                                        }
                                        else {
                                            return {
                                                ...o
                                            }
                                        }
                                    }))
                                    setListWorkFlow(listworkflow?.map((o, index) => {
                                        // console.log("index == param.other", index, param.other);
                                        if (index == param.other) {
                                            // console.log("o.flowConfig.length ", o.flowConfig.length);
                                            return {
                                                ...o,
                                                flowConfig: o.flowConfig.map((v1, step) => {
                                                    if (v1.step == param.step) {
                                                        return {
                                                            ...v1,
                                                            isEdit: true,
                                                            edit: false
                                                        }
                                                    }
                                                    return v1
                                                })
                                            }
                                        }
                                        return o
                                    }))
                                }
                            }} />
                            <DeleteOutlined onClick={() => {
                                handleDelete(() => {
                                    if (param.other == null) {
                                        setList(list.filter(o => o.step != param.step).map((o, step) => {
                                            return {
                                                ...o,
                                                step: step + 1,
                                                isEdit: true
                                            }
                                        }))
                                    } else {
                                        setList(list?.map(o => {
                                            return {
                                                ...o,
                                                isEdit: true,
                                            }
                                        }))
                                        if (param.step == 1) {
                                            setListWorkFlow(
                                                listworkflow.filter((o, index) => index != param.other).map((o, step) => {
                                                    return {
                                                        ...o,
                                                        step: step + 1,
                                                        isEdit: true,
                                                        edit: true
                                                    }
                                                })
                                            )
                                        } else {
                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                if (index == param.other) {
                                                    return {
                                                        ...o,
                                                        flowConfig: o?.flowConfig?.filter((v1, step) => v1.step != param.step)
                                                    }
                                                }
                                                return o
                                            }))
                                        }
                                    }
                                })
                            }} />
                        </span>
                    </Flex>
                </Card>
            </Flex>
        )
    }

    function ApprovebyPerson(props) {
        const { param } = props;
        // console.log("param.other", param.other, param);
        const [edit, setEdit] = useState(param.edit || false)
        return (
            <Flex vertical>{
                param.workFlowConfigType == "REQUESTER" ? <Card
                    styles={{
                        body: {
                            alignContent: "center",
                            padding: "16px 16px 10px 16px",

                            height: "100%"
                        }
                    }}
                    style={{
                        alignSelf: "center",
                        placeContent: "center",
                        display: "flex",
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "transparent",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        textAlign: "center",
                        alignContent: "center",

                    }}>
                    <Flex
                        style={{
                            display: "flex",
                            placeContent: "center",
                            backgroundColor: "#D4EBFF",
                            padding: "0.4vw",
                            textAlign: "center",
                            borderStyle: "solid",
                            borderColor: "#1890FF",
                            borderRadius: "2rem",
                            borderWidth: "2px",
                            color: "#1890FF",
                            fontSize: "0.8vw",
                            width: "7vw"
                        }}>{t("workflow.label.requester")}
                    </Flex>
                </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px",
                                minWidth: "16vw",
                                maxWidth: "16vw",
                            }
                        }}
                        style={{
                            minWidth: "16vw",
                            maxWidth: "16vw",
                            alignSelf: "center",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            // marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param.step - 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
            }
                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        maxWidth: "100%",
                        // height: "7vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "7.5vw",
                            width: "0.1vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex style={{
                            minWidth: "12.5vw",
                            maxWidth: "12.5vw",
                        }} vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.approve_by_individual")}
                            </Flex>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            <Flex vertical style={{
                                rowGap: "8px",
                                // minWidth: "16vw",
                                // maxWidth: "16vw",
                            }}>
                                {edit ? (
                                    <Select
                                        name="person"
                                        placeholder={t("workflow.label.individual")}
                                        size="large"
                                        mode={'multiple'}
                                        value={param?.requesterList?.map?.(o => o.employeeId) || []}
                                        // maxCount={2}
                                        options={modifiedEmployeeOptions
                                            //     [
                                            //     { value: '66d583d09728e465ba901185', label: 'อนุรักษ์ สวัสดี' },
                                            //     { value: '66d694309728e465ba901350', label: 'กิติยาพร จันทรโอภาส' },
                                            //     { value: 'siriwan', label: 'ศิริวรรณ ทุหา' },
                                            // ]
                                        }
                                        filterOption={(input, option) => {
                                            return (option?.fullName + option.fullNameEn ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase());
                                        }}
                                        onChange={(e, option) => {
                                            // console.log("option", option);
                                            // console.log("param.other == null", param.other == null);
                                            if (param.other == null) {
                                                setList(list?.map(o => {
                                                    if (o.step == param.step) {
                                                        return {
                                                            ...o,
                                                            edit: true,
                                                            isEdit: true,
                                                            requesterList: option.map(({ value, name, surName }) => {
                                                                return {
                                                                    employeeId: value,
                                                                    name: name,
                                                                    surname: surName
                                                                }
                                                            },
                                                            )
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...o
                                                        }
                                                    }
                                                }))
                                            } else {
                                                setList(list?.map(o => {
                                                    return {
                                                        ...o,
                                                        isEdit: true,
                                                    }
                                                }))
                                                setListWorkFlow(listworkflow?.map((o, index) => {
                                                    // console.log("index == param.other", index, param.other);
                                                    if (index == param.other) {
                                                        return {
                                                            ...o,
                                                            flowConfig: o.flowConfig.map((v1, step) => {
                                                                if (v1.step == param.step) {
                                                                    return {
                                                                        ...v1,
                                                                        requesterList: option.map(({ value, name, surName }) => {
                                                                            return {
                                                                                employeeId: value,
                                                                                name: name,
                                                                                surname: surName
                                                                            }
                                                                        },
                                                                        ),
                                                                        isEdit: true,
                                                                        edit: true
                                                                    }
                                                                }
                                                                return v1
                                                            })
                                                        }
                                                    }
                                                    return o
                                                }))
                                            }
                                        }}
                                    />
                                ) :
                                    (
                                        <Flex vertical style={{ fontSize: "1vw" }}>
                                            {param?.requesterList?.map?.(o => {
                                                return <span>{modifiedEmployeeOptions?.find?.((v) => o.employeeId == v.value)?.label}</span>
                                            })}
                                        </Flex>
                                    )}
                            </Flex>
                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined style={{ paddingRight: "12px" }} onClick={() => {
                                setEdit(!edit)
                                if (edit) {
                                    if (param.other == null) {
                                        setList(list?.map(o => {
                                            if (o.step == param.step) {
                                                return {
                                                    ...o,
                                                    edit: false,
                                                }
                                            }
                                            else {
                                                return {
                                                    ...o
                                                }
                                            }
                                        }))
                                    }

                                }
                            }} />
                            <DeleteOutlined onClick={() => {
                                handleDelete(() => {
                                    if (param.other == null) {
                                        setList(list.filter(o => o.step != param.step).map((o, step) => {
                                            return {
                                                ...o,
                                                step: step + 1,
                                                isEdit: true
                                            }
                                        }))
                                    } else {
                                        setList(list?.map(o => {
                                            return {
                                                ...o,
                                                isEdit: true,
                                            }
                                        }))
                                        if (param.step == 1) {
                                            setListWorkFlow(
                                                listworkflow.filter((o, index) => index != param.other).map((o, step) => {
                                                    return {
                                                        ...o,
                                                        step: step + 1,
                                                        isEdit: true,
                                                        edit: true
                                                    }
                                                })
                                            )
                                        } else {
                                            setListWorkFlow(listworkflow?.map((o, index) => {
                                                if (index == param.other) {
                                                    return {
                                                        ...o,
                                                        flowConfig: o?.flowConfig?.filter((v1, step) => v1.step != param.step)
                                                    }
                                                }
                                                return o
                                            }))
                                        }
                                    }
                                })

                            }} />
                        </span>
                    </Flex>
                </Card>
            </Flex>
        )
    }

    function requester(param, deindex) {
        // console.log("requester", typeof param, param);
        return (
            <Flex vertical style={{ alignSelf: "end" }}>
                {typeof param != 'number' ?
                    <Card
                        styles={{
                            body: {
                                alignContent: "center",
                                padding: "16px",
                                height: "100%"
                            }
                        }}
                        style={{
                            placeContent: "center",
                            display: "flex",
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            textAlign: "center",
                            alignContent: "center"
                        }}>

                        <Flex
                            style={{
                                display: "flex",
                                placeContent: "center",
                                backgroundColor: "#D4EBFF",
                                padding: "0.4vw",
                                textAlign: "center",
                                borderStyle: "solid",
                                borderColor: "#1890FF",
                                borderRadius: "2rem",
                                borderWidth: "2px",
                                color: "#1890FF",
                                fontSize: "0.8vw",
                                width: "7vw",
                                // marginTop: "1vw"
                            }}>{t("workflow.label.requester")}
                        </Flex>
                    </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            // marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param + 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
                }
                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        // marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "8vw",
                            width: "0.2vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.requester")}
                            </Flex>
                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>{t("workflow.label.individually")}</span>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            {isEditing ? (
                                <Select
                                    name="requestPerson"
                                    placeholder={t("workflow.label.requester")}
                                    size="large"
                                    options={[
                                        { value: 'anurak', label: 'อนุรักษ์ สวัสดี' },
                                        { value: 'gitiyapon', label: 'กิติยาพร จันทรโอภาส' },
                                        { value: 'siriwan', label: 'ศิริวรรณ ทุหา' },
                                    ]}
                                    mode="multiple"
                                />
                            ) : (
                                <>
                                    <Row gutter={24}>
                                        <Col span={12}>
                                            <span style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                                รายชื่อ
                                            </span>
                                        </Col>
                                        <Col span={12} style={{ textAlign: "end" }}>
                                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>
                                                0 คน
                                            </span>
                                        </Col>
                                    </Row>
                                    <Flex vertical>
                                        อนุรักษ์ สวัสดี
                                    </Flex>
                                </>)}

                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined style={{ paddingRight: "12px" }} onClick={handleEditClick} />
                            <DeleteOutlined onClick={() =>
                                setList(list.filter(o => o.step != param.step).map((o, step) => {
                                    return {
                                        ...o,
                                        step: step + 1,
                                        isEdit: true
                                    }
                                }))} />
                        </span>
                    </Flex>
                </Card>
            </Flex>
        )
    }

    function requesterByPosition(param, deindex) {
        return (
            <Flex vertical style={{ alignSelf: "end" }}>
                {typeof param != 'number' ?
                    <Card
                        styles={{
                            body: {
                                alignContent: "center",
                                padding: "0",
                                height: "100%"
                            }
                        }}
                        style={{
                            placeContent: "center",
                            display: "flex",
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            textAlign: "center",
                            alignContent: "center"
                        }}>

                        <Flex
                            style={{
                                display: "flex",
                                placeContent: "center",
                                backgroundColor: "#D4EBFF",
                                padding: "0.4vw",
                                textAlign: "center",
                                borderStyle: "solid",
                                borderColor: "#1890FF",
                                borderRadius: "2rem",
                                borderWidth: "2px",
                                color: "#1890FF",
                                fontSize: "0.8vw",
                                width: "7vw",
                                marginTop: "1vw"
                            }}>{t("workflow.label.requester")}
                        </Flex>
                    </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param + 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
                }
                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "8vw",
                            width: "0.2vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.requester")}
                            </Flex>
                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>{t("workflow.label.specific_position")}</span>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            {isEditing ? (
                                <Select
                                    name="requestPosition"
                                    placeholder={t("home.position")}
                                    size="large"
                                    options={[
                                        { value: 'ceo', label: 'CEO' },
                                        { value: 'itManager', label: 'IT Manager' },
                                        { value: 'finance', label: 'Financial' },
                                    ]}
                                />
                            ) : (
                                <>
                                    <span style={{ color: "#1890FF" }}>
                                        {selectedValue}
                                    </span>
                                </>)}

                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined style={{ paddingRight: "12px" }} onClick={handleEditClick} />
                            <DeleteOutlined onClick={() => handleDelete(deindex)} />
                        </span>
                    </Flex>
                </Card>
            </Flex>
        )
    }

    function requesterByGroup(param, deindex) {
        return (
            <Flex vertical style={{ alignSelf: "end" }}>
                {typeof param != 'number' ?
                    <Card
                        styles={{
                            body: {
                                alignContent: "center",
                                padding: "0",
                                height: "100%"
                            }
                        }}
                        style={{
                            placeContent: "center",
                            display: "flex",
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            textAlign: "center",
                            alignContent: "center"
                        }}>

                        <Flex
                            style={{
                                display: "flex",
                                placeContent: "center",
                                backgroundColor: "#D4EBFF",
                                padding: "0.4vw",
                                textAlign: "center",
                                borderStyle: "solid",
                                borderColor: "#1890FF",
                                borderRadius: "2rem",
                                borderWidth: "2px",
                                color: "#1890FF",
                                fontSize: "0.8vw",
                                width: "7vw",
                                marginTop: "1vw"
                            }}>{t("workflow.label.requester")}
                        </Flex>
                    </Card>
                    : <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            marginTop: "1vw"
                        }}>
                        <Flex style={{ justifyContent: "center", }}>
                            <Flex style={{
                                backgroundColor: "#1890FF",
                                width: "2vw",
                                height: "2vw",
                                justifyContent: "center",
                                borderRadius: "60rem"
                            }}>
                                <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{param + 1}</span>
                            </Flex>
                        </Flex>
                    </Card>
                }
                <Card
                    styles={{
                        body: {
                            padding: "15px"
                        }
                    }}
                    style={{
                        width: "16vw",
                        borderStyle: "solid",
                        borderColor: "#1890FF",
                        borderRadius: "0.5rem",
                        borderWidth: "2px",
                        marginTop: "1vw"
                    }}>

                    <Flex>
                        <Divider style={{
                            height: "8vw",
                            width: "0.2vw",
                            backgroundColor: "#1890FF",
                            borderBlockStart: "none",
                            borderRadius: "1vw"
                        }} type="vertical" />
                        <Flex vertical>
                            <Flex style={{ fontSize: "1vw", width: "11vw", color: "#1890FF" }}>
                                {t("workflow.label.requester")}
                            </Flex>
                            <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>{t("workflow.label.specific_user_group")}</span>
                            <Divider
                                style={{
                                    height: "0.1vw",
                                    width: "0.1vw",
                                    backgroundColor: "#1890FF",
                                    borderBlockStart: "none",
                                    borderRadius: "1vw",
                                    margin: "10px 0px"
                                }} />
                            {isEditing ? (
                                <Select
                                    name="requestByGroup"
                                    placeholder={t("workflow.label.user_group")}
                                    size="large"
                                    options={[
                                        { value: 'ceo', label: 'CEO' },
                                        { value: 'itManager', label: 'IT Manager' },
                                        { value: 'finance', label: 'Financial' },
                                    ]}
                                />
                            ) : (
                                <>
                                    <span style={{ color: "#1890FF" }}>
                                        {selectedValue}
                                    </span>
                                </>)}

                        </Flex>
                        <span style={{ color: "#AEAEAE" }}>
                            <EditOutlined style={{ paddingRight: "12px" }} onClick={handleEditClick} />
                            <DeleteOutlined onClick={() => handleDelete(deindex)} />
                        </span>
                    </Flex>
                </Card>
            </Flex>
        )
    }

    function stepOfNumber(listworkflow) {
        return (
            <Flex vertical style={{
                overflowX: "scroll", paddingTop: "1vw", width: "max-content"
            }}>
                <Flex gap={40} style={{
                    width: "max-content"
                }}>
                    <Card
                        styles={{
                            body: {
                                alignContent: "center",
                                padding: "0",
                                height: "100%"
                            }
                        }}
                        style={{
                            placeContent: "center",
                            display: "flex",
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            textAlign: "center",
                            alignContent: "center"
                        }}>
                        <Flex
                            style={{
                                display: "flex",
                                placeContent: "center",
                                backgroundColor: "#D4EBFF",
                                padding: "0.4vw",
                                textAlign: "center",
                                borderStyle: "solid",
                                borderColor: "#1890FF",
                                borderRadius: "2rem",
                                borderWidth: "2px",
                                color: "#1890FF",
                                fontSize: "0.8vw",
                                width: "7vw"
                            }}>{t("workflow.label.requester")}
                        </Flex>
                    </Card>
                    <Flex style={{ alignContent: "center", textAlign: "center" }}>
                        <RightOutlined style={{ color: "#1890FF", }} />
                    </Flex>
                    {listworkflow.map((o, idx) => {
                        return (
                            <>
                                <Card
                                    styles={{
                                        body: {
                                            padding: "15px"
                                        }
                                    }}
                                    style={{
                                        width: "16vw",
                                        borderStyle: "solid",
                                        borderColor: "transparent",
                                        borderRadius: "0.5rem",
                                        borderWidth: "2px",
                                        marginTop: "1vw"
                                    }}>
                                    <Flex style={{ justifyContent: "center", }}>
                                        <Flex style={{
                                            backgroundColor: "#1890FF",
                                            width: "2vw",
                                            height: "2vw",
                                            justifyContent: "center",
                                            borderRadius: "60rem"
                                        }}>
                                            <span style={{ alignSelf: "center", color: "#FFFF", fontSize: "1vw" }}>{idx + 1}</span>
                                        </Flex>
                                    </Flex>
                                </Card>
                                <Flex style={{ alignContent: "center", textAlign: "center" }}>
                                    <RightOutlined style={{ color: "#1890FF", }} />
                                </Flex>
                            </>
                        )
                    })}
                </Flex>
            </Flex>
        )
    }

    const requestModel = useCallback(
        () => {
            return <>
                <Flex style={{ alignItems: "center" }} vertical>
                    <Card
                        styles={{
                            body: {
                                alignContent: "center",
                                padding: "16px 16px 10px 16px",
                                height: "100%"
                            }
                        }}
                        style={{
                            placeContent: "center",
                            display: "flex",
                            alignSelf: "center",
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "transparent",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                            textAlign: "center",
                            alignContent: "center"
                        }}>
                        <Flex
                            style={{
                                display: "flex",
                                placeContent: "center",
                                backgroundColor: "#D4EBFF",
                                padding: "0.4vw",
                                textAlign: "center",
                                borderStyle: "solid",
                                borderColor: "#1890FF",
                                borderRadius: "2rem",
                                borderWidth: "2px",
                                color: "#1890FF",
                                fontSize: "0.8vw",
                                width: "7vw"
                            }}>{t("workflow.label.requester")}
                        </Flex>

                    </Card>
                    <Card
                        styles={{
                            body: {
                                padding: "15px"
                            }
                        }}
                        style={{
                            width: "16vw",
                            borderStyle: "solid",
                            borderColor: "#1890FF",
                            borderRadius: "0.5rem",
                            borderWidth: "2px",
                        }}>
                        <Flex>
                            <Divider style={{
                                height: "3vw",
                                width: "0.1vw",
                                backgroundColor: "#1890FF",
                                borderBlockStart: "none",
                                borderRadius: "1vw"
                            }} type="vertical" />
                            <Flex vertical>
                                <span style={{ fontSize: "1vw", color: "#1890FF" }}>{i18n.language == "en" ? "Everyone" : "ทุกคน"}</span>
                                <span style={{ fontSize: "1vw", color: "#AEAEAE" }}>{i18n.language == "en" ? "in every company" : "ในทุกบริษัท"}</span>
                            </Flex>
                        </Flex>
                    </Card>
                </Flex>
                <Flex vertical style={{ display: "flex", alignSelf: "center" }}>
                    {PlusDropdown(0)}
                </Flex>
            </>
        },
        [list, setList, PlusDropdown],
    )


    return {
        ChainOfCommand,
        ApproveByRole,
        ApproveByPosition,
        requester,
        PlusDropdown,
        RenderCell,
        list,
        handleAddComponent,
        reset: resetToDefaultFn,
        addNewWorkFlow,
        RenderNewWorkFlow,
        PlusDropdownNew,
        listworkflow,
        RenderCellTwo,
        stepOfNumber,
        handleDelete,
        onDelete,
        onEdit,
        ApprovebyPerson,
        requesterByPosition,
        requesterByGroup,
        HandleSave,
        onCancel
    }
}
export default useWorkFlow;